module.exports = __webpack_public_path__ + "images/zlm_small679badb95107b2b4cf4ca25170c4626e.png";